export default __webpack_public_path__ + "static/media/seat.1108713e.svg";